export default {
  title: 'Pagar',
};
